import * as XLSX from 'xlsx';

export const exportRankingVAF = (empresas) => {
  const dados = empresas.map((e, i) => ({
    '#':              i + 1,
    'CNPJ':           e.cnpj,
    'Empresa':        e.nome,
    'VAF Anterior':   e.vafAnt,
    'VAF Atual':      e.vafAt,
    'Variação %':     e.variacao,
    'Perda (R$)':     e.perda,
    'Status':         e.status,
    'Prazo (dias)':   e.prazo,
  }));
  const ws = XLSX.utils.json_to_sheet(dados);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Ranking VAF');
  XLSX.writeFile(wb, `ranking_vaf_${new Date().toISOString().slice(0,10)}.xlsx`);
};

export const exportContratos = (contratos) => {
  const dados = contratos.map(c => ({
    'Número':         c.numero,
    'Fornecedor':     c.fornecedor,
    'Valor (R$)':     c.valor,
    'Secretaria':     c.secretaria,
    'Município':      c.municipio,
    'IBS Estimado':   c.ibs,
    'Status':         c.status,
  }));
  const ws = XLSX.utils.json_to_sheet(dados);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Contratos IBS');
  XLSX.writeFile(wb, `contratos_ibs_${new Date().toISOString().slice(0,10)}.xlsx`);
};

export const importSEF = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb   = XLSX.read(e.target.result, { type: 'binary' });
        const ws   = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws);
        resolve(data.map(row => ({
          cnpj:    row['CNPJ']            || row['cnpj']    || '',
          nome:    row['Empresa']         || row['empresa'] || row['Razão Social'] || '',
          vafAnt:  parseFloat(row['VAF Ano Anterior'] || row['vaf_anterior'] || 0),
          vafAt:   parseFloat(row['VAF Ano Atual']    || row['vaf_atual']    || 0),
        })));
      } catch(err) { reject(err); }
    };
    reader.readAsBinaryString(file);
  });
};
